import * as _ from 'underscore';

import { ColorBoxField } from '../../../../_common/platform/ts/ColorBoxField';
import NumberField from '../../../../_common/platform/ts/NumberField';
import SelectField from '../../../../_common/platform/ts/SelectField';
import BooleanField from '../../../../_common/platform/ts/BooleanField';
import { FormatChooserField } from '../../../../_common/platform/tsx/FormatChooser';
import { FontBoxField } from '../../../../_common/platform/ts/FontBoxField';

import { validators } from '../../../../_common/platform/ts/validators';
import * as Config from '../config';
// Theme dispatcher module
import * as appTheme from '../../../../_common/platform/ts/appTheme';
// Any dependency themes, which should be initialized before this one
import { init as widgetTheme } from '../../../../pdc-platform/src/ts/themes/widgetTheme';
import { ColorRowsField } from '../Components/ColorRowsField';
import { GaugeRangeContainerField } from '../Components/GaugeRangeContainerField';

// Preview React component
declare var require: any;
var ThemePreview = require('pdc-widget-gauge/src/ts/themes/ThemePreview');

// CSS template for the widget
var template = require('!!raw-loader!pdc-widget-gauge/src/mainTheme.template.css').default;

// A hack, to make sure that TS compiler will include this module as dependency in generated AMD
template;

declare let Color: any;

//declare let pdc: any;

function getDarkIfWhiteAndVV(theme, color) {
    if (Color(theme[color]).dark()) {
        return Color(theme[color]).lighten(10).hexString();
    } else {
        return Color(theme[color]).darken(10).hexString();
    }
}

function getThemeObj() {
    let commonThemes = appTheme.getThemeObj(null);

    return appTheme.extend({}, commonThemes);
}
// This array, which saves all glob objects, on which theme was initialized
// It's used to make sure that `init` is launched only once for each glob.
// Here, it's possible that platform will run init for widgetTheme more than 1 time.
var _init = [];

export function init(glob) {
    // If init already invoked – halt
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }

    // Init parent theme
    widgetTheme(glob);
    let theme = getThemeObj();

    // Register section, which will be displayed on the left of theme edit component
    appTheme.registerSections([
        {
            id: Config.themeId, //see 'widget-gauge',
            name: 'Gauge',
            parent: 'widget',
            preview: ThemePreview,
            previewClassName: 'preview-widget preview-widget-gauge',

            themeType: 'Widget Gauge',
            visibility: ['application', 'workspace', 'pdc-widget-gauge']
        },

        {
            id: 'gauge-fonts', // VR: a SubFolder with all fonts
            name: 'Fonts of tooltips,etc',
            parent: Config.themeId,
            //preview: ThemePreview,
            //previewClassName: 'preview-widget preview-widget-gauge',
            themeType: 'Widget Gauge',
            visibility: ['application', 'workspace', 'pdc-widget-gauge']
        },

        {
            id: 'gauge-circular',
            name: 'Circular',
            parent: Config.themeId,

            preview: ThemePreview,
            previewClassName: 'preview-widget preview-widget-gauge',
            themeType: 'Widget Gauge',
            visibility: ['application', 'workspace', 'pdc-widget-gauge']
        },

        {
            id: 'gauge-linear',
            name: 'Linear',
            parent: Config.themeId,

            preview: ThemePreview,
            previewClassName: 'preview-widget preview-widget-gauge',
            themeType: 'Widget Gauge',
            visibility: ['application', 'workspace', 'pdc-widget-gauge']
        },

        {
            id: 'gauge-bar',
            name: 'Bar',
            parent: Config.themeId,

            preview: ThemePreview,
            previewClassName: 'preview-widget preview-widget-gauge',
            themeType: 'Widget Gauge',
            visibility: ['application', 'workspace', 'pdc-widget-gauge']
        }
    ]);

    appTheme.registerGroups([
        {
            id: 'gauge-title-visible',
            name: 'Gauge Title',
            section: Config.themeId
        },
        {
            id: 'gauge-tooltips',
            name: 'Tooltips',
            section: Config.themeId
        },
        {
            id: 'gauge-line-scale-labels',
            name: 'Scale Labels (Linear & Circular)',
            section: Config.themeId
        },
        {
            id: 'gauge-line-tick',
            name: 'Ticks (Linear & Circular)',
            section: Config.themeId
        },
        {
            id: 'gauge-line-minor-tick',
            name: 'Minor Ticks (Linear & Circular)',
            section: Config.themeId
        },
        {
            id: 'gauge-sub-ranges',
            name: 'Sub Ranges (Linear & Circular)',
            section: Config.themeId
        },

        // ================ BAR ==============================
        {
            id: 'gauge-bar-values',
            name: 'Bar Values',
            section: Config.themeId
        },
        {
            id: 'gauge-font-bar-values',
            name: 'Bar Font Values',
            section: Config.themeId
        },

        {
            id: 'gauge-bar-bars',
            name: 'Bar Geometry and View',
            section: Config.themeId
        },
        {
            id: 'gauge-bar-space-around',
            name: 'Space around the gauge area',
            section: Config.themeId
        },

        // ==================LINEAR ============================
        {
            id: 'gauge-line-main-value-indicator',
            name: 'Main Value Indicator',
            section: Config.themeId
        },
        {
            id: 'gauge-line-sub-value-indicator',
            name: 'Sub Values Indicator',
            section: Config.themeId
        },
        {
            id: 'gauge-line-scale-geometry',
            name: 'Scale Geometry',
            section: Config.themeId
        },

        // ==============CIRCULAR =======================
        {
            id: 'gauge-circle-scale',
            name: 'Scale Visualization',
            section: Config.themeId
        },
        {
            id: 'gauge-circle-main-value-indicator',
            name: 'Main Value Indicator',
            section: Config.themeId
        },
        {
            id: 'gauge-circle-sub-value-indicator',
            name: 'Sub Value Indicators',
            section: Config.themeId
        },
        {
            id: 'gauge-circle-scale-geometry',
            name: 'Scale Geometry',
            section: Config.themeId
        }
    ]);

    // Register theme variables
    appTheme.registerVars([
        // ------------- general tab ----------------

        // Tick major ---------------------------
        {
            id: 'gauge-line-tick-visible',
            param: new BooleanField(glob, 'Visible', [], true),
            section: Config.themeId,
            group: 'gauge-line-tick'
        },
        {
            id: 'gauge-line-tick-length',
            param: new NumberField(glob, 'Tick Length', [], 4),
            section: Config.themeId,
            group: 'gauge-line-tick'
        },
        {
            id: 'gauge-line-tick-width',
            param: new NumberField(glob, 'Tick Width', [], 2),
            section: Config.themeId,
            group: 'gauge-line-tick'
        },
        {
            id: 'gauge-line-tick-color',
            param: new ColorBoxField(glob, 'Tick Color', [], '#FFFFFF', {
                hideTransparency: true
            }),
            section: Config.themeId,
            group: 'gauge-line-tick'
        },
        {
            id: 'gauge-line-tick-intervals',
            param: new NumberField(glob, 'Interval Value (use "0" for auto)', [], 0),
            section: Config.themeId,
            group: 'gauge-line-tick'
        },
        //gauge-line-tick

        // Tick MINOR  ---------------------------
        {
            id: 'gauge-line-tick-minor-visible',
            param: new BooleanField(glob, 'Visible', [], false),
            section: Config.themeId,
            group: 'gauge-line-minor-tick'
        },
        {
            id: 'gauge-line-tick-minor-length',
            param: new NumberField(glob, 'Tick Length', [], 3),
            section: Config.themeId,
            group: 'gauge-line-minor-tick'
        },
        {
            id: 'gauge-line-tick-minor-width',
            param: new NumberField(glob, 'Tick Width', [], 1),
            section: Config.themeId,
            group: 'gauge-line-minor-tick'
        },
        {
            id: 'gauge-line-tick-minor-color',
            param: new ColorBoxField(glob, 'Tick Color', [], '#FFFFFF', {
                hideTransparency: true
            }),
            section: Config.themeId,
            group: 'gauge-line-minor-tick'
        },
        //gauge-line-minor-tick

        // Sub Ranges -----------------------------
        {
            id: 'range-color-as-percentage',
            param: new BooleanField(glob, 'Use Sub Range values as percentages (in the range 0-100%)', [], false),
            section: Config.themeId,
            group: 'gauge-sub-ranges'
        },
        {
            id: 'gauge-ranges',
            param: new GaugeRangeContainerField(this.glob, '', [], null, {
                noTitle: true //LL: to save space at the top of field;  title:'' is not enough
            }),
            section: Config.themeId,
            group: 'gauge-sub-ranges'
        },
        //gauge-sub-ranges

        // ------------- BAR ----------------------
        // BAR SCALE ------------------
        {
            id: 'widget-gauge-bar_labelIndent',
            param: new NumberField(this.glob, 'Distance to Labels', [], 15),
            section: 'gauge-bar',
            group: 'gauge-bar-values'
        },
        {
            id: 'widget-gauge-bar_labelConnectorWidth',
            param: new NumberField(
                this.glob,
                'Label Connector Width',
                [validators.number.range(0, 6), validators.number.integer],
                2
            ),
            section: 'gauge-bar',
            group: 'gauge-bar-values'
        },
        {
            id: 'widget-gauge-bar_labelOverlapping',
            param: new BooleanField(this.glob, 'Hide certain labels when they overlapped', [], true),
            section: 'gauge-bar',
            group: 'gauge-bar-values'
        },

        // BAR GEOMETRY ===============
        {
            id: 'widget-gauge-bar_relativeInnerRadius',
            param: new NumberField(
                this.glob,
                'Relation between the radiuses of Max and Min bars',
                [validators.number.not_negative, validators.number.range(0.1, 1.0)],
                0.3,
                {
                    integer: false
                }
            ),
            section: 'gauge-bar',
            group: 'gauge-bar-bars'
        },

        {
            id: 'widget-gauge-bar-background-color',
            param: new ColorBoxField(
                this.glob,
                'Segment Background Color',
                [],
                function (theme) {
                    return getDarkIfWhiteAndVV(theme, 'surface-bg');
                },
                {
                    hideTransparency: false
                }
            ),
            section: 'gauge-bar',
            group: 'gauge-bar-bars',
            deps: ['surface-bg']
        },
        {
            id: 'widget-gauge-bar_spacing',
            param: new NumberField(
                this.glob,
                'Distance between Bars',
                [validators.number.not_negative, validators.number.integer, validators.number.range(0, 40)],
                4
            ),
            section: 'gauge-bar',
            group: 'gauge-bar-bars'
        },
        {
            id: 'widget-gauge-palette-color',
            param: new ColorRowsField(
                this.glob,
                'Bar Palette',
                [],
                {
                    defaultPaletteName: 'Material',
                    customPaletteArray: ['#333399'],
                    arr: [{ name: 'basic', color: '#333399' }]
                },
                {}
            ),
            section: 'gauge-bar',
            group: 'gauge-bar-bars'
        },
        {
            id: 'widget-gauge-bar_geometry-start-angle',
            param: new NumberField(
                this.glob,
                'Arc Start Angle',
                [validators.number.range(-360, 360), validators.number.integer],
                225
            ),
            section: 'gauge-bar',
            group: 'gauge-bar-bars'
        },
        {
            id: 'widget-gauge-bar_geometry-end-angle',
            param: new NumberField(
                this.glob,
                'Arc End Angle',
                [validators.number.range(-360, 360), validators.number.integer],
                315
            ),
            section: 'gauge-bar',
            group: 'gauge-bar-bars'
        },
        {
            id: 'widget-gauge-bar_baseValue',
            param: new NumberField(this.glob, 'Base Value', [], 0),
            section: 'gauge-bar',
            group: 'gauge-bar-bars'
        },

        // BAR SPACE AROUND ===================
        {
            id: 'widget-gauge-bar_marginBottom',
            param: new NumberField(
                this.glob,
                'Margin Bottom',
                [validators.number.not_negative, validators.number.integer, validators.number.range(-10, 40)],
                10
            ),
            section: 'gauge-bar',
            group: 'gauge-bar-space-around'
        },
        {
            id: 'widget-gauge-bar_marginLeft',
            param: new NumberField(
                this.glob,
                'Margin Left',
                [validators.number.not_negative, validators.number.integer, validators.number.range(-10, 40)],
                0
            ),
            section: 'gauge-bar',
            group: 'gauge-bar-space-around'
        },
        {
            id: 'widget-gauge-bar_marginRight',
            param: new NumberField(
                this.glob,
                'Margin Right',
                [validators.number.not_negative, validators.number.integer, validators.number.range(-10, 40)],
                0
            ),
            section: 'gauge-bar',
            group: 'gauge-bar-space-around'
        },
        {
            id: 'widget-gauge-bar_marginTop',
            param: new NumberField(
                this.glob,
                'Margin Top',
                [validators.number.not_negative, validators.number.integer, validators.number.range(-10, 40)],
                0
            ),
            section: 'gauge-bar',
            group: 'gauge-bar-space-around'
        },

        //-------------- LINEAR  ---------------------
        // LINEAR values format==================
        // Line MAIN INDICATOR -----------------
        {
            id: 'gauge-line_valuesFormat',
            param: new FormatChooserField(glob, 'Format', [], null, {
                value: {},
                theme: theme,
                isScalar: true,
                isNoValue: true,
                customizeFormat: true,
                showStyle: false,
                showTemplate: false,
                showRawTemplate: false
            }),
            section: 'gauge-linear',
            group: 'gauge-line-main-value-indicator'
        },
        {
            id: 'gauge-line-main-indicator-type',
            param: new SelectField(this.glob, 'Type', [], 'rangeBar', {
                values: ['rectangle', 'circle', 'rhombus', 'rangeBar', 'triangleMarker', 'textCloud'],
                display: ['Rectangle', 'Circle', 'Rhombus', 'Rangebar', 'Triangle Marker', 'Text Cloud']
            }),
            section: 'gauge-linear',
            group: 'gauge-line-main-value-indicator'
        },
        {
            id: 'gauge-line-main-indicator-color',
            param: new ColorBoxField(
                glob,
                'Color',
                [],
                function (theme) {
                    return Color(theme['primary-bg']).hexString();
                },
                { hideTransparency: true }
            ),
            section: 'gauge-linear',
            group: 'gauge-line-main-value-indicator',
            deps: ['primary-bg']
        },
        {
            id: 'gauge-line-main-indicator-backcolor',
            param: new ColorBoxField(
                glob,
                'Background Color (for range)',
                [],
                function (theme) {
                    return Color(theme['body-bg']).hexString();
                },
                { hideTransparency: false }
            ),
            section: 'gauge-linear',
            group: 'gauge-line-main-value-indicator',
            deps: ['body-bg']
        },
        {
            id: 'gauge-line-main-indicator-offset',
            param: new NumberField(glob, 'Offset (distance between indicator & scale)', [], 25),
            section: 'gauge-linear',
            group: 'gauge-line-main-value-indicator'
        },
        {
            id: 'gauge-line-main-indicator-size',
            param: new NumberField(glob, 'Size of range indicator', [], 10),
            section: 'gauge-linear',
            group: 'gauge-line-main-value-indicator'
        },
        {
            id: 'gauge-line-main-indicator-font-size',
            param: new NumberField(glob, 'Font Size (for range & cloud)', [validators.number.range(8, 24)], 12),
            section: 'gauge-linear',
            group: 'gauge-line-main-value-indicator'
        },
        {
            id: 'gauge-line-main-indicator-font-color',
            param: new ColorBoxField(
                glob,
                'Font Color (for range & cloud)',
                [],
                function (theme) {
                    return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.4).hexString();
                },
                { hideTransparency: true }
            ),
            section: 'gauge-linear',
            group: 'gauge-line-main-value-indicator',
            deps: ['gray-base', 'surface-bg']
        },
        //gauge-line-main-value-indicator

        // Line SUB INDICATOR -----------------
        {
            id: 'gauge-line_sub-valuesFormat',
            param: new FormatChooserField(glob, 'Label Format', [], null, {
                value: {},
                theme: theme,
                isScalar: true,
                isNoValue: true,
                customizeFormat: true,
                showStyle: false,
                showTemplate: false,
                showRawTemplate: false
            }),
            section: 'gauge-linear',
            group: 'gauge-line-sub-value-indicator'
        },
        {
            id: 'gauge-line-sub-indicator-type',
            param: new SelectField(this.glob, 'indicator Type', [], 'textCloud', {
                values: ['rectangle', 'circle', 'rhombus', 'rangeBar', 'triangleMarker', 'textCloud'],
                display: ['Rectangle', 'Circle', 'Rhombus', 'Rangebar', 'Triangle Marker', 'Text Cloud']
            }),
            section: 'gauge-linear',
            group: 'gauge-line-sub-value-indicator'
        },
        {
            id: 'gauge-line-sub-indicator-color',
            param: new ColorBoxField(glob, 'Background Color', [], '#ffea00', {
                hideTransparency: true
            }),
            section: 'gauge-linear',
            group: 'gauge-line-sub-value-indicator'
        },
        {
            id: 'gauge-line-sub-indicator-length',
            param: new NumberField(glob, 'SubIndicator length', [], 16),
            section: 'gauge-linear',
            group: 'gauge-line-sub-value-indicator'
        },
        {
            id: 'gauge-line-sub-indicator-offset',
            param: new NumberField(glob, 'Offset (distance between subindicator & scale)', [], -18),
            section: 'gauge-linear',
            group: 'gauge-line-sub-value-indicator'
        },

        {
            id: 'gauge-line-sub-indicator-font-size',
            param: new NumberField(glob, 'Label Font Size', [validators.number.range(8, 48)], 24),
            section: 'gauge-linear',
            group: 'gauge-line-sub-value-indicator'
        },
        {
            id: 'gauge-line-sub-indicator-font-color',
            param: new ColorBoxField(
                glob,
                'Font Color',
                [],
                function (theme) {
                    return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.4).hexString();
                },
                { hideTransparency: true }
            ),
            section: 'gauge-linear',
            group: 'gauge-line-sub-value-indicator',
            deps: ['gray-base', 'surface-bg']
        },
        //gauge-line-sub-value-indicator

        // Line Geometry ----------------------------
        {
            id: 'gauge-line-geometry-orientation',
            param: new SelectField(this.glob, 'Geometry Orientation', [], 'horizontal', {
                values: ['horizontal', 'vertical'],
                display: ['Horizontal', 'Vertical']
            }),
            section: 'gauge-linear',
            group: 'gauge-line-scale-geometry'
        },
        {
            id: 'gauge-line-scale-width',
            param: new NumberField(glob, 'Scale Container Width', [], 15),
            section: 'gauge-linear',
            group: 'gauge-line-scale-geometry'
        },
        {
            id: 'gauge-line-scale-offset',
            param: new NumberField(glob, 'Scale Offset', [], 0),
            section: 'gauge-linear',
            group: 'gauge-line-scale-geometry'
        },
        {
            id: 'gauge-line-scale-color',
            param: new ColorBoxField(
                glob,
                'Scale Color',
                [],
                function (theme) {
                    return Color(theme['secondary-bg']).hexString();
                },
                { hideTransparency: false }
            ),
            section: 'gauge-linear',
            group: 'gauge-line-scale-geometry',
            deps: ['secondary-bg']
        },
        //gauge-line-scale-geometry

        //-------------- CIRCLE  ---------------------
        //  circle MAIN INDICATOR -----------------
        {
            id: 'gauge-circle-main-indicator-type',
            param: new SelectField(this.glob, 'Type', [], 'triangleNeedle', {
                values: ['rectangleNeedle', 'triangleNeedle', 'twoColorNeedle', 'rangeBar', 'triangleMarker'],
                display: ['Rectangle Needle', 'Triangle Needle', 'Two Color Needle', 'Range Bar', 'Triangle Marker']
            }),
            section: 'gauge-circular',
            group: 'gauge-circle-main-value-indicator'
        },
        {
            id: 'gauge-circle-main-indicator-color',
            param: new ColorBoxField(
                glob,
                'Color',
                [],
                function (theme) {
                    return Color(theme['primary-bg']).hexString();
                },
                { hideTransparency: true }
            ),
            section: 'gauge-circular',
            group: 'gauge-circle-main-value-indicator',
            deps: ['primary-bg']
        },
        {
            id: 'gauge-circle-main-indicator-offset',
            param: new NumberField(glob, 'Offset (distance between indicator & scale)', [], 10),
            section: 'gauge-circular',
            group: 'gauge-circle-main-value-indicator'
        },
        {
            id: 'gauge-circle-main-indicator-width',
            param: new NumberField(glob, 'Width of indicator', [], 16),
            section: 'gauge-circle',
            group: 'gauge-circle-main-value-indicator'
        },

        //  circle SUB INDICATOR -----------------
        {
            id: 'gauge-circle-sub-valuesFormat',
            param: new FormatChooserField(glob, 'Label Format', [], null, {
                value: {},
                theme: theme,
                isScalar: true,
                isNoValue: true,
                customizeFormat: true,
                showStyle: false,
                showTemplate: false,
                showRawTemplate: false
            }),
            section: 'gauge-circular',
            group: 'gauge-circle-sub-value-indicator'
        },
        {
            id: 'gauge-circle-sub-indicator-type',
            param: new SelectField(this.glob, 'Sub Indicators Type', [], 'twoColorNeedle', {
                values: ['rectangleNeedle', 'triangleNeedle', 'twoColorNeedle', 'triangleMarker', 'textCloud'],
                display: ['Rectangle Needle', 'Triangle Needle', 'Two Color Needle', 'Triangle Marker', 'Text Cloud']
            }),
            section: 'gauge-circular',
            group: 'gauge-circle-sub-value-indicator'
        },
        {
            id: 'gauge-circle-sub-indicator-color',
            param: new ColorBoxField(glob, 'Color', [], '#8798A5', {
                hideTransparency: true
            }),
            section: 'gauge-circular',
            group: 'gauge-circle-sub-value-indicator'
        },
        {
            id: 'gauge-circle-sub-indicator-width',
            param: new NumberField(glob, 'SubIndicator width', [], 4),
            section: 'gauge-circular',
            group: 'gauge-circle-sub-value-indicator'
        },
        {
            id: 'gauge-circle-sub-indicator-offset',
            param: new NumberField(glob, 'Offset to Scale)', [], 20),
            section: 'gauge-circular',
            group: 'gauge-circle-sub-value-indicator'
        },

        {
            id: 'gauge-circle-sub-indicator-font-size',
            param: new NumberField(glob, 'Font Size', [validators.number.range(8, 24)], 12),
            section: 'gauge-circular',
            group: 'gauge-circle-sub-value-indicator'
        },
        {
            id: 'gauge-circle-sub-indicator-font-color',
            param: new ColorBoxField(
                glob,
                'Font Color',
                [],
                function (theme) {
                    return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.4).hexString();
                },
                { hideTransparency: true }
            ),
            section: 'gauge-circular',
            group: 'gauge-circle-sub-value-indicator',
            deps: ['gray-base', 'surface-bg']
        },
        //gauge-line-sub-value-indicator

        // circle Geometry ----------------------------
        {
            id: 'gauge-circle-start-angle',
            param: new NumberField(
                this.glob,
                'Arc Start Angle',
                [validators.number.range(-360, 360), validators.number.integer],
                225
            ),
            section: 'gauge-circular',
            group: 'gauge-circle-scale'
        },
        {
            id: 'gauge-circle-end-angle',
            param: new NumberField(
                this.glob,
                'Arc End Angle',
                [validators.number.range(-360, 360), validators.number.integer],
                315
            ),
            section: 'gauge-circular',
            group: 'gauge-circle-scale'
        },
        {
            id: 'gauge-circle-scale-offset',
            param: new NumberField(glob, 'Scale Offset', [], 0),
            section: 'gauge-circular',
            group: 'gauge-circle-scale'
        },
        {
            id: 'gauge-circle-scale-width',
            param: new NumberField(glob, 'Scale Container Width', [], 5),
            section: 'gauge-circular',
            group: 'gauge-circle-scale'
        },
        {
            id: 'gauge-circle-scale-color',
            param: new ColorBoxField(
                glob,
                'Scale Color',
                [],
                function (theme) {
                    return Color(theme['secondary-bg']).hexString();
                },
                { hideTransparency: false }
            ),
            section: 'gauge-circular',
            group: 'gauge-circle-scale',
            deps: ['secondary-bg']
        },
        //gauge-circle-scale

        // FONTS SEction: ==============================================
        // TOOLTIP ===============
        {
            id: 'widget-gauge-tooltipVisible',
            param: new BooleanField(this.glob, 'Tooltip Visible', [], true),
            section: 'gauge-fonts',
            group: 'gauge-tooltips'
        },
        {
            id: 'widget-gauge-tooltipFormat',
            param: new FormatChooserField(this.glob, 'Tooltip Format', [], null, {
                value: {},
                theme: theme,
                isScalar: true,
                isNoValue: true,
                customizeFormat: true,
                showStyle: false,
                showTemplate: false,
                showRawTemplate: false
            }),
            section: 'gauge-fonts',
            group: 'gauge-tooltips'
        },
        {
            id: 'widget-gauge-tooltipBackColor',
            param: new ColorBoxField(this.glob, 'Background Color', [], 'rgba(255, 255, 255, 1)', {
                hideTransparency: false
            }),
            section: 'gauge-fonts',
            group: 'gauge-tooltips'
        },
        // {
        //     id: 'widget-gauge-tooltipFontSize',
        //     param: new NumberField(this.glob, 'Font Size',
        //         [validators.number.not_negative, validators.number.integer,
        //             validators.number.range(8, 24)], 12),
        //     section: 'gauge-fonts', group: 'gauge-tooltips'
        // },
        // {
        //     id: 'widget-gauge-tooltipFontColor',
        //     param: new ColorBoxField(
        //         this.glob, 'Font Color', [], 'rgba(35, 35, 35, 1)',
        //         {hideTransparency: false}),
        //     section: 'gauge-fonts', group: 'gauge-tooltips'
        // },
        {
            id: 'gauge-font-tooltip',
            param: new FontBoxField(
                glob,
                'Font in Tooltips',
                [],
                function (theme) {
                    return {
                        face: theme['#font-main'],
                        size: theme['font-main-size'],
                        weight: theme['font-main-weight'],
                        color: 'rgba(35, 35, 35, 1)'
                    };
                },
                { showColor: true }
            ),
            section: 'gauge-fonts',
            group: 'gauge-tooltips',
            deps: ['#font-main', 'font-main-weight']
        },

        // scale labels:
        {
            id: 'gauge-scale_label-visible',
            param: new BooleanField(this.glob, 'Scale Labels Visible', [], true),
            section: 'gauge-fonts',
            group: 'gauge-line-scale-labels'
        },
        {
            id: 'gauge-scale_label-format',
            param: new FormatChooserField(this.glob, 'Format', [], null, {
                value: {},
                theme: theme,
                isScalar: true,
                isNoValue: true,
                customizeFormat: true,
                showStyle: false,
                showTemplate: false,
                showRawTemplate: false
            }),
            section: 'gauge-fonts',
            group: 'gauge-line-scale-labels'
        },
        // {
        //     id: 'gauge-scale-label-font-size',
        //     param: new NumberField(
        //         this.glob, 'Font Size', [
        //             validators.number.range(8, 24)
        //         ], 12),
        //     section: 'gauge-fonts', group: 'gauge-line-scale-labels'
        // },
        // {
        //     id: 'gauge-scale-label-font-color',
        //     param: new ColorBoxField(
        //         this.glob,
        //         'Font Color',
        //         [],
        //         function (theme) {
        //             return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.4).hexString();
        //         },
        //         {hideTransparency: false}
        //     ),
        //     section: 'gauge-fonts', group: 'gauge-line-scale-labels',
        //     deps: ['gray-base', 'surface-bg']
        // },
        {
            id: 'gauge-font-scale-label',
            param: new FontBoxField(
                glob,
                'Font of Scale Labels',
                [],
                function (theme) {
                    return {
                        face: theme['#font-main'],
                        size: theme['font-main-size'],
                        weight: theme['font-main-weight'],
                        color: Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.4).hexString()
                    };
                },
                { showColor: true }
            ),
            section: 'gauge-fonts',
            group: 'gauge-line-scale-labels',
            deps: ['#font-main', 'font-main-weight']
        },
        {
            id: 'gauge-scale-label-use-range-color',
            param: new BooleanField(glob, 'Use Range Color', [], false),
            section: 'gauge-fonts',
            group: 'gauge-line-scale-labels'
        },

        // bar font values:
        {
            id: 'widget-gauge-bar_labelVisible',
            param: new BooleanField(glob, 'Bar Values Visible', [], true),
            section: 'gauge-fonts',
            group: 'gauge-font-bar-values'
        },
        {
            id: 'widget-gauge-bar_valuesFormat',
            param: new FormatChooserField(glob, 'Format', [], null, {
                value: {},
                theme: theme,
                isScalar: true,
                isNoValue: true,
                customizeFormat: true,
                showStyle: false,
                showTemplate: false,
                showRawTemplate: false
            }),
            section: 'gauge-fonts',
            group: 'gauge-font-bar-values'
        },
        // {
        //     id: 'widget-gauge-bar_labelFontColor',
        //     param: new ColorBoxField(
        //         this.glob, 'Font Color', [], 'rgba(158, 158, 158, 1)',
        //         { hideTransparency: false }),
        //     section: 'gauge-fonts', group: 'gauge-font-bar-values'
        // },
        // {
        //     id: 'widget-gauge-bar_labelFontSize',
        //     param: new NumberField(this.glob, 'Font Size',
        //         [validators.number.not_negative, validators.number.integer,
        //             validators.number.range(8, 24)], 12),
        //     section: 'gauge-fonts', group: 'gauge-font-bar-values'
        // },
        {
            id: 'gauge-bar-values-font',
            param: new FontBoxField(
                glob,
                'Font of Bar Values',
                [],
                function (theme) {
                    return {
                        face: theme['#font-main'],
                        size: theme['font-main-size'],
                        weight: theme['font-main-weight'],
                        color: 'rgba(158, 158, 158, 1)'
                    };
                },
                { showColor: true }
            ),
            section: 'gauge-fonts',
            group: 'gauge-font-bar-values',
            deps: ['#font-main', 'font-main-weight']
        },
        {
            id: 'widget-gauge-bar-scaleLabel_UseRangeColors',
            param: new BooleanField(glob, 'Use Range Colors', [], true),
            section: 'gauge-fonts',
            group: 'gauge-font-bar-values'
        },

        // Title --------------------
        {
            id: 'gauge-title-visible',
            param: new BooleanField(this.glob, 'Show Gauge Title', [], true),
            section: 'gauge-fonts',
            group: 'gauge-title-visible'
        },
        {
            id: 'gauge-title-font',
            param: new FontBoxField(
                glob,
                'Font of Gauge Title',
                [],
                function (theme) {
                    return {
                        face: theme['#font-main'],
                        size: theme['font-main-size'],
                        weight: theme['font-main-weight'],
                        color: theme['gray-base']
                    };
                },
                { showColor: true }
            ),
            section: 'gauge-fonts',
            group: 'gauge-title-visible',
            deps: ['#font-main', 'font-main-weight']
        }
    ]);

    // Register templates
    appTheme.registerTemplate(template, ['pdc-widget-gauge']);

    appTheme.registerPreRender(function (input) {
        let vars = {};
        return _.extend(input, vars);
    });
    _init.push(glob);
}
